export default {
  ASC: 'asc',
  DESC: 'desc',
  ASCENDING: 'ascending ',
  DESCENDING: 'descending',
};
